export default "__VITE_ASSET__cee616b8__"